import { computePosition, flip, shift, offset } from '@floating-ui/vue';
import { nextTick } from 'vue';
import { useEventListener } from '@vueuse/core';
let c = 0;
const TT_TIMEOUT = Symbol('tt-timeout');
const TT_ANIMATION = Symbol('tt-animation');
const TT_TRANSITION_HANDLER = Symbol('tt-transition-handler');
const appear = (el, opt) => {
    if (!el.getAttribute('ui-title') && !el.getAttribute('title'))
        return;
    opt = opt || {};
    let uId = el.dataset?.uittId;
    if (!uId) {
        let ttId = `tt-${c++}`;
        el.dataset.uittId = ttId;
    }
    let ttContainer = document.getElementById(el.dataset.uittId);
    if (!ttContainer) {
        ttContainer = document.createElement('div');
        ttContainer.id = el.dataset.uittId;
        ttContainer.classList.add('text-sm', 'max-w-[320px]', 'absolute', 'bg-neutral-950/90', 'text-white', 'p-2', 'rounded-md', 'transition-opacity', 'z-[100000]');
        ttContainer.style.opacity = '0';
        ttContainer.style.display = 'none';
        ttContainer.setAttribute('role', 'tooltip');
        document.body.appendChild(ttContainer);
        ttContainer.addEventListener('transitionend', () => {
            if (ttContainer.style.opacity === '0') {
                ttContainer.remove();
            }
        });
    }
    const update = () => {
        ttContainer.innerHTML = el.getAttribute('ui-title') || el.getAttribute('title');
        computePosition(el, ttContainer, {
            placement: opt.placement || 'top',
            middleware: [offset(4), flip(), shift({ padding: 4 })]
        }).then(({ x, y }) => {
            Object.assign(ttContainer.style, {
                left: `${x}px`,
                top: `${y}px`
            });
        });
    };
    nextTick(() => {
        ttContainer.style.display = 'block';
        requestAnimationFrame(() => {
            ttContainer.style.opacity = '1';
        });
        update();
        // Limpa qualquer animationFrame anterior
        if (el[TT_ANIMATION])
            cancelAnimationFrame(el[TT_ANIMATION]);
        const monitorMouseOver = () => {
            const isMouseOver = el.matches(':hover') || ttContainer.matches(':hover');
            if (!isMouseOver) {
                disappear(el);
            }
            else {
                el[TT_ANIMATION] = requestAnimationFrame(monitorMouseOver);
            }
        };
        el[TT_ANIMATION] = requestAnimationFrame(monitorMouseOver);
    });
};
const disappear = (el) => {
    const uId = el.dataset.uittId;
    if (!uId)
        return;
    const ttContainer = document.getElementById(uId);
    if (!ttContainer)
        return;
    // Limpa timeout e animationFrame anteriores
    if (el[TT_TIMEOUT]) {
        clearTimeout(el[TT_TIMEOUT]);
        el[TT_TIMEOUT] = undefined;
    }
    if (el[TT_ANIMATION]) {
        cancelAnimationFrame(el[TT_ANIMATION]);
        el[TT_ANIMATION] = undefined;
    }
    // Remove tooltip, mas garante remoção forçada após 300ms (por segurança)
    const removeTooltip = () => {
        if (ttContainer.parentNode) {
            ttContainer.remove();
        }
        el.removeAttribute('aria-describedby');
    };
    // Garante que só um transitionend handler será adicionado
    if (!el[TT_TRANSITION_HANDLER]) {
        const transitionHandler = () => {
            if (ttContainer.style.opacity === '0') {
                removeTooltip();
                ttContainer.removeEventListener('transitionend', transitionHandler);
                el[TT_TRANSITION_HANDLER] = undefined;
            }
        };
        el[TT_TRANSITION_HANDLER] = transitionHandler;
        ttContainer.addEventListener('transitionend', transitionHandler);
    }
    // Força remoção caso transitionend não dispare
    el[TT_TIMEOUT] = setTimeout(() => {
        removeTooltip();
        if (el[TT_TRANSITION_HANDLER]) {
            ttContainer.removeEventListener('transitionend', el[TT_TRANSITION_HANDLER]);
            el[TT_TRANSITION_HANDLER] = undefined;
        }
    }, 300);
    setTimeout(() => {
        ttContainer.style.opacity = '0';
    }, 20);
};
const onMouseEnter = (el, binding) => {
    appear(el, binding);
};
const onMouseLeave = (el) => {
    disappear(el);
};
export default {
    mounted(el, binding) {
        if (binding.value === false)
            return;
        useEventListener(el, 'mouseenter', () => {
            if (el.title) {
                el.setAttribute('ui-title', el.title);
                el.removeAttribute('title');
            }
            onMouseEnter(el, binding.value);
        });
        useEventListener(el, 'mouseleave', () => {
            onMouseLeave(el);
        });
    },
    unmounted(el) {
        const uId = el.dataset.uittId;
        if (uId) {
            const ttContainer = document.getElementById(uId);
            if (ttContainer)
                ttContainer.remove();
        }
        if (el[TT_ANIMATION]) {
            cancelAnimationFrame(el[TT_ANIMATION]);
            el[TT_ANIMATION] = undefined;
        }
        if (el[TT_TIMEOUT]) {
            clearTimeout(el[TT_TIMEOUT]);
            el[TT_TIMEOUT] = undefined;
        }
        if (el[TT_TRANSITION_HANDLER]) {
            const ttContainer = document.getElementById(uId);
            if (ttContainer)
                ttContainer.removeEventListener('transitionend', el[TT_TRANSITION_HANDLER]);
            el[TT_TRANSITION_HANDLER] = undefined;
        }
        el.removeAttribute('aria-describedby');
        el.removeAttribute('ui-title');
    }
};
